module.exports = __webpack_public_path__ + "static/media/spl-logo.3f15989f.jpg";